/**
 * Created by hernanherreros on 2019-05-02
 */

import * as React from 'react'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import Inline from './Inline'

interface Props {
  title?: string;
  help?: string | React.ReactNode
  align: 'left' | 'center' | 'right' | 'between';
  showBorder?: boolean;
  layout?: 'block' | 'flex'
}

interface State {
}

export default class Section extends React.Component<Props, State> {
  static defaultProps = {
    layout: 'block',
    align: 'left',
    showBorder: true,
  }

  static Inline = Inline

  state = {}

  render() {
    const { showBorder } = this.props

    return (
      <SectionContainer showBorder={showBorder}>
        {this.renderTitle()}
        <Row gutter={36}>
          {this.renderContent()}
          {this.renderHelp()}
        </Row>
      </SectionContainer>
    )
  }

  renderTitle () {
    const { title } = this.props

    if (!title) {
      return null
    }

    return (
      <Title>{title}</Title>
    )
  }

  renderContent () {
    const { children, help, align, layout } = this.props

    const colProps = help ? {
      lg: 14,
      xs: 24,
    } : {}

    return (

      <Col {...colProps}>
        <Wrapper align={align} layout={layout}>
          {children}
        </Wrapper>
      </Col>
    )
  }

  renderHelp () {
    const { help } = this.props

    if (!help) {
      return null
    }

    const colProps = {
      lg: 10,
      xs: 24,
    }

    if (typeof help === 'string') {
      return (
        <Col {...colProps}>
          <Help>{help}</Help>
        </Col>
      )
    } else {
      return (
        <Col {...colProps}>
          {help}
        </Col>
      )
    }
  }
}

const SectionContainer = styled.section<any>`
  
  ${({showBorder}) => showBorder && `
    border-bottom: 1px solid #ececec;
    padding-top: 24px;
  `}
  
  &:last-child {
    border-bottom: none;
  }
`

const Title = styled.h1`
  margin-bottom: 20px;
`

const Help = styled.span`
  color: #AAA;
  font-weight: 300;
  font-size: 13px;
`

const Wrapper = styled.div<any>`
  display: ${({layout}) => layout};
  width: 100%;
    
  ${({align}) => {
    if (align === 'between') {
      return `justify-content: space-between;`
    } else {
      return `text-align: ${align};`
    }
  }}
`